<template>
    <v-app>
        <div>
            <v-app-bar class="elevation-0" color="primary">
                <div class="container">
                    <img src="./assets/logo.png" />
                    <v-toolbar-title>
                        MedSchoolCoach
                    </v-toolbar-title>
                    <v-spacer />
                    <v-toolbar-title v-if="this.$store.getters.user.state">
                        <v-btn
                            class="ml-2"
                            @click="restart"
                            small
                            color="error"
                        >
                            Restart
                        </v-btn>
                    </v-toolbar-title>
                </div>
            </v-app-bar>

            <v-main v-if="validated">
                <router-view :key="$route.fullPath" />
            </v-main>
            <v-card v-else id="auth">
                <v-card-title>
                    Login required
                </v-card-title>
                <v-card-text>
                    <v-form v-on:submit.prevent="validatePassword">
                        <v-alert type="error" v-if="error">
                            Password incorrect, please contact your the head of
                            advising to get access
                        </v-alert>
                        <v-text-field
                            type="password"
                            label="Enter Password"
                            v-model="password"
                        ></v-text-field>
                        <v-btn color="secondary" @click="validatePassword">
                            Go
                        </v-btn>
                    </v-form>
                </v-card-text>
            </v-card>
        </div>
    </v-app>
</template>

<script>
export default {
    name: 'App',

    created() {
        this.isCookieSet();

        this.$store.dispatch('loadSchools');

        document.title = 'MedSchoolCoach - School List Generator';
    },
    data: () => ({
        password: String,
        error: false,
        validated: false,
    }),
    methods: {
        setCookie() {
            this.$cookies.set(
                'validated',
                'validated',
                new Date().getTime() + 90 * 24 * 60 * 60 * 1000
            );
        },

        isCookieSet() {
            if ('validated' === this.$cookies.get('validated')) {
                this.validated = true;
            }
        },

        validatePassword() {
            if ('mscadvising' === this.password) {
                this.setCookie();
                this.isCookieSet();
                return;
            }

            this.error = true;
        },

        restart() {
            this.$store.dispatch('reset');
            this.$router.push('/');
        },
    },
};
</script>
<style lang="scss">
header {
    .container {
        display: flex;
        margin-top: 1em;
        padding: 0;

        .v-toolbar__title {
            color: white;
            margin: 11px 0 0 1em;
        }
    }
}

#auth {
    margin: 1em auto;
    max-width: 1000px;
}
</style>
